export const TAG_MODEL = "tag";
export const PUBLISHING_SCHEDULE_TAG = "publishing-schedule-tag";

const tagModel = {
  name: ""
};

export default tagModel;
